/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";

import { Grid, Typography, Currency, Box } from "@/components/core";
import { CurrencyFlag, IbanCard } from "@/components/common";

export function AccountCardMinimal({ account, onClick, sx }: any) {
  return (
    <Box
      sx={{
        p: 1.5,
        color: "inherit",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        ...sx,
      }}
      onClick={() => onClick(account.custAccountsId)}
    >
      <Grid spacing={2} alignItems="flex-start" sx={{ flexWrap: "nowrap" }}>
        <Grid.Item>
          <CurrencyFlag currency={account.currencyName} />
        </Grid.Item>
        <Grid.Item>
          <Currency variant="h6" amount={account.balance} currency={account.currencyName} />
          <Grid.Item>
            <Typography>{account.iban}</Typography>
          </Grid.Item>
        </Grid.Item>
      </Grid>
      <Box sx={{ pl: 0.5, pr: 0.5, mt: 1 }}>
        {account?.sepaIban && <IbanCard iban={account.sepaIban} />}
      </Box>
    </Box>
  );
}

AccountCardMinimal.propTypes = {
  account: PropTypes.shape({
    currencyName: PropTypes.string,
    balance: PropTypes.number,
    iban: PropTypes.string,
    sepaIban: PropTypes.string,
    custAccountsId: PropTypes.string,
  }),
  onClick: PropTypes.func,
  sx: PropTypes.object,
};
